import $ from 'jquery';
window.$ = window.jQuery = $;
import whatInput from 'what-input';

/* Vendor */
import './vendor/modernizr-custom';
import './vendor/foundation';

$(function () {  
    $(document).foundation();
		
    $('img').on('error', function () {
        $(this).hide();
    });

    $('p').each(function() {
        var $this = $(this);
        if($this.html().replace(/\s|&nbsp;/g, '').length == 0){
            $this.remove(); 
        }
    });

    if(Foundation.MediaQuery.atLeast('large')){
        $('.menu--sub li.menu__item').each(function(i){
            var $this = $(this),
                $aside = $this.parents('.menu__mega').find('.menu__aside');
            
            if($this.hasClass('menu__item--has-children')){
                var $subsub = $this.find('> .menu--subsub');
                $this.attr('data-sub',i);
                $subsub.attr('data-sub',i);

                $subsub.clone().appendTo($aside);
            }

            $this.hover(function(){
                $('.menu--sub li.menu__item--has-children').removeClass('active');

                if($this.hasClass('menu__item--has-children')){
                    $this.addClass('active');
                    $aside.find('.block--callout, > .menu--subsub').removeClass('active');
                    $aside.find('> .menu--subsub[data-sub="'+$this.data('sub')+'"]').addClass('active');
                } else {
                    $aside.find('.block--callout').addClass('active');
                    $aside.find('> .menu--subsub').removeClass('active');
                }
            });
        })
    } else {
        $('.menu__item__trigger').click(function(){
            var $this = $(this),
                $sub = $this.next('.menu__item__children');

            $sub.toggle();
        });
    }

    $('.block--riskmap').each(function(){
        var $this = $(this),
            $summary = $this.find('.summary');

        $this.find('polygon, path').click(function(){
            var $poly = $(this);
            
            if($poly.data('summary')){
                $summary.html($poly.data('summary'));
            }
            else if($poly.parent().data('summary')){
                $summary.html($poly.parent().data('summary'));
            }
        })
    });

    if (!Modernizr.objectfit) {
        $('.block__figure').each(function () {
            var $container = $(this),
                imgUrl = $container.find('img').prop('src');
            
            if (imgUrl) {
                $container
                    .css('backgroundImage', 'url(' + imgUrl + ')')
                    .addClass('block__figure--fallback');
            }  
        });
    }

    var $teasers = $('.block--teaser .block__content');

    function equalise($items){
        if($(window).width() > 460){
            var highest = 0;
            $items.each(function(i, el){
                el.style.height = 'auto';
                var el_height = $(el).height();
                if(el_height > highest){
                    highest = el_height;
                }
            });
            $items.each(function(i, el){
                el.style.height = (highest+100+'px');
            });
        } else {
            $items.each(function(i, el){
                el.style.height = 'auto';
            });
        }
    }

    $(window).on('load', function(){
        equalise($teasers);
    });

    $(window).on('resize', function(){
        equalise($teasers);
    });
});


// WEBPACK FOOTER //
// ./_UI/js/app.js